



















import { defineComponent, ref } from '@vue/composition-api'
import { mapActions } from '@/store/utils'
import { GenericObject } from '@/inc/types'
import gsap from 'gsap'
import YouTubePlayer from 'youtube-player'

export default defineComponent({
  props: {
    id: {
      type: String || null,
      default: () => null,
    },
  },
  setup(props, ctx) {
    const player = ref<GenericObject | null>(null)
    const iframe = ref<HTMLDivElement | null>(null)
    const { removeId } = mapActions(ctx, 'cinema', ['removeId'])

    const anims = {
      beforeEnter(el) {
        gsap.set(el, { opacity: 0 })
      },
      enter(el, done) {
        const body = document.querySelector('body')

        player.value = YouTubePlayer('cinema-iframe', {
          videoId: props.id,
        }) as GenericObject

        body && body.classList.add('is-locked')

        gsap.to(el, 0.5, {
          opacity: 1,
          ease: 'power4.out',
          onComplete: () => {
            done()
          },
        })
      },
      afterEnter() {
        setTimeout(() => {
          player.value && player.value.playVideo()
        }, 300)
      },
      leave(el, done) {
        const body = document.querySelector('body')

        body && body.classList.remove('is-locked')

        gsap.to(el, 0.5, {
          opacity: 0,
          ease: 'power4.inOut',
          onComplete: () => {
            player.value && player.value.destroy()
            done()
          },
        })
      },
    }

    return {
      anims,
      iframe,
      removeId,
    }
  },
})
